// Shared core for the storefront wine & bar builders.
// Loaded (blocking) immediately before each section's inline script —
// window.OCBuilder is the contract; both builders bind from it.
window.OCBuilder = (function () {
  'use strict';

  // ── Store stock rule (matches the collection grid + Shopify cart) ──
  // Visibility: actual/supplier/allocation stock or core list (the grid's
  // BASE_FILTER). Cart cap: supplier/allocation/core items sell on Shopify
  // inventory_policy 'continue' (uncapped); everything else caps at the
  // synced Shopify inventory — exactly what /cart/add.js enforces.
  var TS = { host: 'iuotzvrsg98xbfdlp.a2.typesense.net', key: 'NdSXMEVc5c1rjbHeORk2d6zuE4kwqzS8' };
  var stockInfo = {}; // variantId -> { buyable, cap, scarce }

  function enrichStock(variantIds) {
    var need = [];
    variantIds.forEach(function (id) {
      id = String(id);
      if (id && !(id in stockInfo) && need.indexOf(id) === -1) need.push(id);
    });
    if (!need.length) return Promise.resolve();
    var searches = [];
    for (var i = 0; i < need.length; i += 250) {
      searches.push({ collection: 'stocks', q: '*', query_by: 'name', per_page: 250,
        filter_by: 'shopify_variant_id:[' + need.slice(i, i + 250).join(',') + ']',
        include_fields: 'shopify_variant_id,actual_available_stock,supplier_stock,allocation_qty,core_list,stock_onshore,stock_client,stock_allocations' });
    }
    return fetch('https://' + TS.host + '/multi_search?x-typesense-api-key=' + TS.key, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ searches: searches }),
    }).then(function (r) { return r.json(); }).then(function (data) {
      (data.results || []).forEach(function (res) {
        (res.hits || []).forEach(function (h) {
          var d = h.document || {};
          setStock(String(d.shopify_variant_id), stockFromDoc(d));
        });
      });
      // Not in the search index = not on the storefront grid: fail closed.
      need.forEach(function (id) { if (!stockInfo[id]) stockInfo[id] = { buyable: false, cap: 0, scarce: 0 }; });
    }).catch(function () {
      // Typesense blip: fail open on Shopify's own availability so shelves keep working.
      need.forEach(function (id) { if (!stockInfo[id]) stockInfo[id] = { buyable: true, cap: 99, scarce: 0 }; });
    });
  }
  function stockFromDoc(d) {
    var actual = Number(d.actual_available_stock) || 0;
    var sup = Number(d.supplier_stock) || 0;
    var alloc = Number(d.allocation_qty) || 0;
    var core = d.core_list === true;
    var external = core || sup > 0 || alloc > 0; // inventory_policy 'continue'
    var synced = Math.max(0, Math.floor((Number(d.stock_onshore) || 0) + (Number(d.stock_client) || 0) + (Number(d.stock_allocations) || 0)));
    return {
      buyable: actual > 0 || sup > 0 || alloc > 0 || core,
      cap: external ? 99 : Math.min(99, synced),
      scarce: (!core && actual > 0 && actual <= 6) ? Math.round(actual) : 0,
    };
  }
  function setStock(vid, info) { if (vid) stockInfo[String(vid)] = info; }
  function stockFor(vid) { return stockInfo[String(vid)] || { buyable: true, cap: 99, scarce: 0 }; }

  // Storefront convention: split by vintage and size — "2019 - Name - Magnum"
  function displayTitle(pr, v) {
    var names = (pr.options || []).map(function (o) { return String(o && o.name ? o.name : o).toLowerCase(); });
    var vals = [v.option1, v.option2, v.option3];
    var vint = '', size = '';
    names.forEach(function (n, i) {
      if (n === 'vintage' && vals[i]) vint = vals[i];
      if (n === 'size' && vals[i]) size = vals[i];
    });
    var sizeLabel = size === '150cl' ? 'Magnum' : size === '37.5cl' ? 'Half bottle' : size === '300cl' ? 'Double Magnum' : (size && size !== '75cl' && size !== '70cl' ? size : '');
    return (vint ? vint + ' - ' : '') + pr.title + (sizeLabel ? ' - ' + sizeLabel : '');
  }
  // Standard bottles first, max N formats per product per shelf
  function stdFirstVariants(pr, max) {
    var names = (pr.options || []).map(function (o) { return String(o && o.name ? o.name : o).toLowerCase(); });
    var si = names.indexOf('size');
    function isStd(v) {
      var s = si === -1 ? '' : [v.option1, v.option2, v.option3][si] || '';
      return s === '' || s === '75cl' || s === '70cl';
    }
    var avail = (pr.variants || []).filter(function (v) { return v && v.available !== false; });
    return avail.filter(isStd).concat(avail.filter(function (v) { return !isStd(v); })).slice(0, max);
  }

  // Titles and image urls reach us from a SHARED list (anyone can POST one and
  // mail the ?list= link), so nothing from a list may reach innerHTML raw.
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  // Non-blocking notice (replaces alert): auto-sizes its stay to the message
  function toast(msg, kind) {
    var t = document.createElement('div');
    t.className = 'oc-toast' + (kind === 'err' ? ' oc-toast--err' : '');
    t.setAttribute('role', 'status');
    String(msg).split('\n').forEach(function (line) { var p = document.createElement('div'); p.textContent = line; t.appendChild(p); });
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { t.remove(); }, 350); }, Math.min(9000, 3200 + String(msg).length * 22));
  }

  function makeMoney(moneyFormat) {
    return function (cents) {
      var s = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, s).replace(/<[^>]+>/g, '');
    };
  }

  // Interaction telemetry (session-scoped, fire-and-forget)
  function makeLogEvent(page, sessionId) {
    return function (event, payload) {
      try {
        var body = JSON.stringify({ session: sessionId, page: page, event: event, payload: payload || {} });
        var url = '/apps/portal/builder/events';
        if (navigator.sendBeacon) navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));
        else fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true }).catch(function () {});
      } catch (e) {}
    };
  }

  // The one true add-to-cart: click-time stock re-check, per-item clamp
  // against what's already in the cart (named notes), and partial-add
  // recovery — Shopify can 422 AFTER adding what it could; if our lines
  // landed we carry on to the cart page instead of stranding the guest.
  // cfg: { lines(), companion()|null, cartUrl, cartPage, itemWord, soldOutMsg, onExit(cart, dest) }
  function makeAddToCart(cfg) {
    return function addToCart(btn, dest) {
      var lines = cfg.lines();
      var comp = cfg.companion ? cfg.companion() : null;
      var ids = Object.keys(lines).filter(function (vid) { return lines[vid].qty > 0; });
      if (comp && comp.on) {
        Object.keys(comp.items).forEach(function (vid) {
          if (comp.items[vid].qty > 0 && ids.indexOf(vid) === -1) ids.push(vid);
        });
      }
      if (!ids.length) return;
      var original = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding…';
      enrichStock(ids).then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); }).catch(function () { return { items: [] }; });
      }).then(function (cart0) {
        var inCart0 = {};
        (cart0.items || []).forEach(function (ci) { inCart0[String(ci.variant_id)] = (inCart0[String(ci.variant_id)] || 0) + ci.quantity; });
        var items = [], notes = [];
        ids.forEach(function (vid) {
          var want = (lines[vid] ? lines[vid].qty : 0) + (comp && comp.on && comp.items[vid] ? comp.items[vid].qty : 0);
          var title = (lines[vid] && lines[vid].title) || (comp && comp.items[vid] && comp.items[vid].title) || ('This ' + cfg.itemWord);
          var cap = Math.min(stockFor(vid).cap, 99);
          var have = inCart0[String(vid)] || 0;
          var q = Math.min(want, Math.max(0, cap - have));
          if (cap < 1) notes.push(title + ' has just sold out.');
          else if (q < 1) notes.push('The maximum available of ' + title + ' is already in your cart (' + have + ').');
          else if (q < want) notes.push('Only ' + (cap - have) + ' more of ' + title + ' available — added ' + q + ' of ' + want + '.');
          if (q > 0) items.push({ id: parseInt(vid, 10), quantity: q });
        });
        if (!items.length) throw new Error(notes.join('\n') || cfg.soldOutMsg);
        return fetch(cfg.cartUrl + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        }).then(function (r) {
          return fetch('/cart.js').then(function (cr) { return cr.json(); }).catch(function () { return {}; }).then(function (cart) {
            var inCart = {};
            (cart.items || []).forEach(function (ci) { inCart[String(ci.variant_id)] = true; });
            var missing = items.filter(function (i) { return !inCart[String(i.id)]; });
            if (!r.ok && missing.length === items.length) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
            // Partial add: keep the list so the guest can retry the rest —
            // clearing it here used to strand them at a short cart.
            if (missing.length) notes.push(missing.length + ' of your ' + cfg.itemWord + 's could not be added, so your list is kept for another try.');
            if (notes.length) toast(notes.join('\n'));
            if (!missing.length) cfg.onExit(cart, dest);
            // Give the availability note a beat to be read before navigating
            setTimeout(function () { window.location.href = dest || cfg.cartPage; }, notes.length ? 2600 : 0);
          });
        });
      }).catch(function (err) {
        btn.disabled = false; btn.textContent = original;
        toast(err.message, 'err');
      });
    };
  }

  return {
    TS: TS,
    enrichStock: enrichStock,
    setStock: setStock,
    stockFromDoc: stockFromDoc,
    stockFor: stockFor,
    displayTitle: displayTitle,
    stdFirstVariants: stdFirstVariants,
    esc: esc,
    toast: toast,
    makeMoney: makeMoney,
    makeLogEvent: makeLogEvent,
    makeAddToCart: makeAddToCart,
  };
})();
